import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PowerRestart.svg",
  "use": "PowerRestart.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"PowerRestart.svg\"><path d=\"M32.01,56.0208a24,24,0,1,1,24-24A24,24,0,0,1,32.01,56.0208Zm0-44a20,20,0,1,0,20,20A20,20,0,0,0,32.01,12.0208Zm3.9726,30.704-15.02-8.9907a1.9963,1.9963,0,0,1,0-3.4261l15.02-8.9907A2.0038,2.0038,0,0,1,39.0156,23.03V41.0117A2.0042,2.0042,0,0,1,35.983,42.7248Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol